import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'carrier',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.insurance_company_phone_associations[props.index] = next
    })
  }
}
